// extracted by mini-css-extract-plugin
module.exports = {"title":"_3jZ2s","setPass_modal":"nUrM5"};